import * as React from "react";
import styled, { css } from "../../../styled/index";
import { Modal } from "../../layout/modal/index";
import { ModalContent } from "../../layout/modal/content";
import { shadeAlternate } from "../../../styled/helpers";
const SelectWrapper = styled("div") `
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => shadeAlternate(0.25, theme.box.background)}; 
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => shadeAlternate(0.45, theme.box.background)}; 
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => shadeAlternate(0.50, theme.box.background)}; 
  }
`;
const SelectItem = styled("div") `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => shadeAlternate(0.1, theme.box.background)};
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.05, theme.box.background)};
  }
  ${({ disabled, theme }) => !disabled ? "" : css `
    cursor: not-allowed;
    background: ${shadeAlternate(0.1, theme.box.background)};
	& p {
		opacity: 0.25;
	}
	&:hover {
		background: ${shadeAlternate(0.1, theme.box.background)};
	}
  `}
`;
export class SelectModal extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.active) {
            setTimeout(() => {
                const el = document.getElementById(this.props.innerId);
                if (el) {
                    el.scrollTop = 0;
                }
            }, 50);
        }
    }
    render() {
        const { innerId, title, options, onSelect, children } = this.props;
        return (React.createElement(Modal, Object.assign({ closeButton: true }, this.props),
            React.createElement(ModalContent, { className: "text-center" },
                React.createElement("p", { className: "big" }, title)),
            React.createElement(ModalContent, { paddinglr: 0, paddingtb: 0 },
                React.createElement(SelectWrapper, { id: innerId }, options.map((o, i) => {
                    return (React.createElement(SelectItem, { key: i, disabled: o.disabled, onClick: () => {
                            if (!o.disabled)
                                onSelect(o);
                        } },
                        React.createElement("p", null, o.label),
                        o.sublabel && React.createElement("p", { className: "small font-semi-bold m-t-1" }, o.sublabel)));
                }))),
            children));
    }
}
//# sourceMappingURL=index.js.map